import styled from '@emotion/styled';
import { keyframes } from '@mui/system';
import { Button as MuiButton, CircularProgress as MuiLoader } from '@mui/material';
import { Close } from '@mui/icons-material';

export const getGlobalStyles = background => ({
  body: {
    background: `url(${background}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    fontFamily: 'Roboto',
    marginBottom: '1rem',
  },
});

export const CloseIcon = styled(Close)`
  cursor: pointer;
  font-size: 1.2em;
  margin-top: 0.2rem;
  margin-right: 0.3rem;
`;

export const FreshchatLoader = styled(MuiLoader)`
  position: absolute;
  color: white;
  top: 6px;
  right: 4px;
  z-index: 1;
`;

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
`;

export const Logo = styled.img`
  filter: drop-shadow(5px 5px 5px #909090);
  margin-bottom: 0.5rem;
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  ${({ theme }) => theme.breakpoints.up(550)} {
    margin-left: ${({ isContact }) => (isContact ? '4.5rem' : 'unset')};
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 1px;
  width: 40%;
  ${({ theme }) => theme.breakpoints.down(1700)} {
    width: 45%;
  }
  ${({ theme }) => theme.breakpoints.down(1600)} {
    width: 50%;
  }
  ${({ theme }) => theme.breakpoints.down(1450)} {
    width: 55%;
  }
  ${({ theme }) => theme.breakpoints.down(1250)} {
    width: 60%;
  }
  ${({ theme }) => theme.breakpoints.down(1100)} {
    width: 65%;
  }
  ${({ theme }) => theme.breakpoints.down(1100)} {
    width: 70%;
  }
  ${({ theme }) => theme.breakpoints.down(900)} {
    width: 75%;
  }
  ${({ theme }) => theme.breakpoints.down(800)} {
    width: 80%;
  }
  ${({ theme }) => theme.breakpoints.down(750)} {
    width: 85%;
  }
  ${({ theme }) => theme.breakpoints.down(650)} {
    width: 90%;
  }
  ${({ theme }) => theme.breakpoints.down(600)} {
    width: 95%;
  }
  ${({ theme }) => theme.breakpoints.down(550)} {
    flex-direction: column;
    gap: 0.5rem;
    width: 85%;
  }
`;

export const ContactIcons = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 3rem;
  padding: 1.5rem 1rem;
  gap: 1rem;
  height: max-content;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  ${({ theme }) => theme.breakpoints.down(550)} {
    flex-direction: row;
    padding: 0.5rem 0;
    width: 100%;
    gap: 2rem;
  }
`;

const push = keyframes`
  50% { transform: scale(0.6); }
`;

export const Icon = styled.img`
  filter: drop-shadow(0px 1px 5px #a5a5a5);
  cursor: pointer;
  max-width: 50px;
  animation: ${push} 0.7s ease;
  transition: 0.2s;
  &:hover {
    transform: scale(1.1);
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: wrap;
  background-color: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  gap: 1.5rem;
  ${({ theme }) => theme.breakpoints.down(550)} {
    gap: 1rem;
  }
`;

export const Title = styled.h1`
  margin: 0;
  padding: 1rem;
  font-weight: 500;
  text-align: center;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
`;

export const SucessMessage = styled.p`
  margin: 0;
  font-size: 1.5em;
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.01em;
  padding: 0 1rem;
`;

export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 2rem;
  ${({ theme }) => theme.breakpoints.down(550)} {
    align-items: stretch;
    flex-direction: column;
  }
`;
export const Field = styled.div`
  display: flex;
  align-items: ${({ alignCenter }) => (alignCenter ? 'center' : 'flex-end')};
  flex: 40%;
`;

export const Button = styled(MuiButton)`
  padding: 0.5rem 0;
`;
